import { FeatureFlag, models } from '@ps/web-core-store';
import type { Select as CoreSelect, Slicer as CoreSlicer, SystemState } from '@ps/web-core-store';

import { subscribe } from '@swf/core/api/subscribe';
import type {
  EffectParams,
  ModelConfig,
  RootState,
  SelectorCreator,
  Slicer
} from '@swf/core/store';

interface SystemMessage {
  body: SystemState;
}

const ONE_MINUTE = 60 * 1000;

interface CoreSystemEffects {
  check(_: undefined, params: EffectParams): Promise<void>;
  checkCore(_: undefined, { dispatch, request }: EffectParams): Promise<void>;
  checkSports(_: undefined, { select, dispatch, request, rootState }: EffectParams): Promise<void>;
}

// cast to make CoreSystemEffects compatible with SW
const effects = {
  ...(models.system.effects as unknown as CoreSystemEffects),
  async subscribe(_: undefined, { select, dispatch, rootState }: EffectParams) {
    subscribe<SystemMessage>('/topic/system/status').subscribe(dispatch.system.update);
    if (select.feature.check(rootState, FeatureFlag.ISPStatusCheck)) {
      setInterval(dispatch.system.checkSports, ONE_MINUTE);
    }
  }
};

interface SystemModel extends ModelConfig<SystemState> {
  reducers: typeof models.system.reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

type MappedSelect = {
  [key in keyof CoreSelect['system']]: () => (
    rootState: RootState
  ) => ReturnType<CoreSelect['system'][key]>;
};

const selectors = (slice: Slicer<SystemState>, createSelector: SelectorCreator) => ({
  ...(models.system.selectors(
    slice as CoreSlicer<SystemState>,
    createSelector
  ) as unknown as MappedSelect)
});

const system: SystemModel = {
  state: {},
  reducers: models.system.reducers,
  effects,
  selectors
};

export default system;
